const REQUIRED_PRESSES = 3
const RESET_DELAY_MS = 5000
const LARGE_DESKTOP_BREAKPOINT = 990

const SR_MESSAGES = [
  '',
  'Press Shift 2 more times to hide this page',
  'Press Shift 1 more time to hide this page'
]

module.exports = ({ scope = document, navigate } = {}) => {
  const quickExits = scope.querySelectorAll('.hse-quick-exit')

  if (!quickExits.length) {
    return () => {}
  }

  const doNavigate = navigate || ((url) => window.location.assign(url))

  const cleanups = []

  quickExits.forEach((container) => {
    const exitLink = container.querySelector('.hse-button')
    const liveRegion = container.querySelector('[role="status"]')

    if (!exitLink || !liveRegion) {
      return
    }

    const exitUrl = exitLink.getAttribute('href')
    let shiftCount = 0
    let resetTimer = null

    const reset = () => {
      shiftCount = 0
      clearTimeout(resetTimer)
      liveRegion.textContent = ''
    }

    const handleKeyUp = (event) => {
      if (!document.body.contains(container)) {
        return
      }

      if (event.key !== 'Shift') {
        reset()
        return
      }

      if (event.ctrlKey || event.altKey || event.metaKey) {
        return
      }

      clearTimeout(resetTimer)
      shiftCount += 1

      if (shiftCount >= REQUIRED_PRESSES) {
        liveRegion.textContent = 'Leaving this page'
        shiftCount = 0
        clearTimeout(resetTimer)
        doNavigate(exitUrl)
        return
      }

      liveRegion.textContent = SR_MESSAGES[shiftCount]
      resetTimer = setTimeout(reset, RESET_DELAY_MS)
    }

    const handlePageShow = () => {
      if (!document.body.contains(container)) {
        return
      }
      reset()
    }

    document.addEventListener('keyup', handleKeyUp)
    window.addEventListener('pageshow', handlePageShow)

    cleanups.push(() => {
      clearTimeout(resetTimer)
      document.removeEventListener('keyup', handleKeyUp)
      window.removeEventListener('pageshow', handlePageShow)
    })
  })

  const updateBodyPadding = () => {
    if (window.innerWidth >= LARGE_DESKTOP_BREAKPOINT) {
      document.body.style.removeProperty('padding-bottom')
      return
    }
    document.body.style.paddingBottom = `${quickExits[0].offsetHeight}px`
  }

  updateBodyPadding()
  window.addEventListener('resize', updateBodyPadding)

  cleanups.push(() => {
    window.removeEventListener('resize', updateBodyPadding)
    document.body.style.removeProperty('padding-bottom')
  })

  return () => cleanups.forEach((fn) => fn())
}
